import { formatDate } from "@/lib/site";
import type { Topic } from "@/types/content";

export default function TopicTimeline({ topic }: { topic: Topic }) {
  return (
    <ol className="relative space-y-8 border-l border-background-200 pl-6 md:pl-8">
      {topic.timeline.map((node, index) => (
        <li key={`${node.date}-${node.title}`} className="relative">
          <span
            className={`absolute -left-[31px] top-1 h-3.5 w-3.5 rounded-full border-2 border-background-50 md:-left-[39px] ${
              index === 0 ? "bg-primary-500" : "bg-background-400"
            }`}
            aria-hidden="true"
          />
          <div className="flex flex-wrap items-center gap-2">
            <time className="font-heading text-sm font-bold text-foreground-900">
              {formatDate(node.date)}
            </time>
            {index === 0 ? (
              <span className="rounded-full bg-primary-100 px-2 py-[2px] text-[11px] font-medium text-primary-700">
                最新节点
              </span>
            ) : null}
          </div>
          <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950">
            {node.title}
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">{node.detail}</p>
        </li>
      ))}
    </ol>
  );
}